import { useLingui } from '@lingui/react';
import { formatMoneyFixed } from '@wkda/funnel-utils';
import { CheckIcon, CheveronRightIcon } from '@wkda/icons';
import { Button } from '@wkda/styleguide';
import cx from 'classnames';
import { useCallback, useEffect } from 'react';
import { useGetDateInfoByTimeZone } from '../../hooks/useBannerReturnCustomer';
import { useCarleadConfiguration } from '../../hooks/useCarleadCreationConfiguration';
import { useCarleadDataLayer } from '../../hooks/useCarleadDataLayer';
import { useTrackCustomerBanner } from '@wkda/funnel-components';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function BannerContentNoShow(_ref) {
  let {
    cityBranch,
    startDate,
    bookingUrl,
    hideCarDetails,
    offerPrice,
    isDoi,
    manufacturer,
    translationPrefix
  } = _ref;
  const {
    i18n: _i18n
  } = useLingui();
  const dataLayer = useCarleadDataLayer();
  const {
    weekday,
    date,
    time
  } = useGetDateInfoByTimeZone(startDate ?? '');
  const {
    locale
  } = useCarleadConfiguration();
  const formattedPriceWithCurrency = formatMoneyFixed(locale, offerPrice ?? 0);
  const {
    trackShownEvent,
    trackCTAClickEvent,
    getCJTrackingButtonNameByAttr
  } = useTrackCustomerBanner();
  const translateUsps = translationPrefix === 'noShowOnSiteRCB' ? [_i18n._(`carleadCreation.${translationPrefix}.fristGoodOption`), _i18n._(`carleadCreation.${translationPrefix}.secondGoodOption`)] : [_i18n._(`carleadCreation.${translationPrefix}.fristGoodOption`), _i18n._(`carleadCreation.${translationPrefix}.secondGoodOption`), _i18n._(`carleadCreation.${translationPrefix}.thirdGoodOption`)];
  const titleShort = offerPrice ? _i18n._(`carleadCreation.${translationPrefix}.titlePriceShort`, {
    manufacturer
  }) : _i18n._(`carleadCreation.${translationPrefix}.titleNoPriceShort`, {
    manufacturer
  });
  const titleFull = offerPrice ? _i18n._(`carleadCreation.${translationPrefix}.titlePriceFull`, {
    manufacturer
  }) : _i18n._(`carleadCreation.${translationPrefix}.titleNoPriceFull`, {
    manufacturer
  });
  useEffect(() => {
    dataLayer.pushCustomerBannerOpen('no-show');
    trackShownEvent('no-show');
  }, [dataLayer, trackShownEvent]);
  const handleButtonClick = useCallback(e => {
    const ctaName = getCJTrackingButtonNameByAttr(e.currentTarget);
    if (ctaName) {
      trackCTAClickEvent('no-show', ctaName);
    }
  }, [getCJTrackingButtonNameByAttr, trackCTAClickEvent]);
  return /*#__PURE__*/_jsx("div", {
    className: `container no-show-rcb`,
    children: /*#__PURE__*/_jsxs("div", {
      className: "row text-center",
      children: [/*#__PURE__*/_jsxs("div", {
        className: "col-sm-12 col-md-3",
        children: [/*#__PURE__*/_jsx("div", {
          className: "no-show-rcb__title",
          children: _i18n._(`carleadCreation.${translationPrefix}.titleAppointment`)
        }), /*#__PURE__*/_jsxs("ul", {
          className: "no-show-rcb__list-appointment",
          children: [/*#__PURE__*/_jsxs("li", {
            className: "no-show-rcb__list-appointment-item no-show-rcb__list-appointment-item--date",
            children: [weekday, ", ", date]
          }), /*#__PURE__*/_jsx("li", {
            className: "no-show-rcb__list-appointment-item no-show-rcb__list-appointment-item--time",
            children: time
          }), /*#__PURE__*/_jsx("li", {
            className: "no-show-rcb__list-appointment-item no-show-rcb__list-appointment-item--location d-none d-sm-inline-block",
            children: cityBranch
          })]
        }), /*#__PURE__*/_jsx("hr", {
          className: "d-md-none"
        })]
      }), /*#__PURE__*/_jsxs("div", {
        className: "col-sm-12 col-md-6 d-flex justify-content-center align-items-center no-show-rcb__col-2",
        children: [!hideCarDetails && /*#__PURE__*/_jsxs("div", {
          className: "no-show-rcb__price-wrapper",
          children: [/*#__PURE__*/_jsxs("div", {
            className: "no-show-rcb__title",
            children: [/*#__PURE__*/_jsx("span", {
              className: "d-none d-md-block",
              children: titleFull
            }), /*#__PURE__*/_jsx("span", {
              className: "d-md-none",
              children: titleShort
            })]
          }), /*#__PURE__*/_jsx("div", {
            className: cx('banner-return-customer__price no-show-rcb__price', {
              'banner-return-customer__pixelated-price no-show-rcb__pixelated-price': isDoi
            }),
            children: !isDoi || !offerPrice ? formattedPriceWithCurrency : ''
          })]
        }), /*#__PURE__*/_jsx(Button, {
          "data-cj-tracking-button-name": "view-booking-button",
          component: "a",
          variant: "secondary",
          size: "lg",
          href: bookingUrl,
          onClick: handleButtonClick,
          children: /*#__PURE__*/_jsxs("div", {
            className: "d-flex justify-content-center align-items-center",
            children: [/*#__PURE__*/_jsx("span", {
              className: "d-none d-md-block",
              children: _i18n._(`carleadCreation.${translationPrefix}.ctaBookingFull`)
            }), /*#__PURE__*/_jsx("span", {
              className: "d-md-none",
              children: _i18n._(`carleadCreation.${translationPrefix}.ctaBookingShort`)
            }), /*#__PURE__*/_jsx(CheveronRightIcon, {
              className: "ml-2"
            })]
          })
        })]
      }), /*#__PURE__*/_jsx("div", {
        className: "col-md-3 d-none d-md-flex",
        children: /*#__PURE__*/_jsx("ul", {
          className: "no-show-rcb__list-checkmarks d-flex justify-content-center",
          children: translateUsps.map(usp => /*#__PURE__*/_jsxs("li", {
            className: "no-show-rcb__list-checkmarks-item d-flex align-items-center",
            children: [/*#__PURE__*/_jsx(CheckIcon, {
              className: "no-show-rcb__list-checkmarks-icon"
            }), ' ', usp]
          }, usp))
        })
      })]
    })
  });
}